if (!globalThis.location) {
  (globalThis.location as any) = { hostname: '' };
}

export let Identity: 'coevera' | 'pipeliner' = location.hostname.includes('coevera.com')
  ? 'coevera'
  : 'pipeliner';

if (globalThis.localStorage) {
  const identityOverride = globalThis.localStorage.getItem('identityOverride');

  if (identityOverride === 'coevera' || identityOverride === 'pipeliner') {
    Identity = identityOverride;
  }
}

export const IdentityHostname = (Identity === 'coevera')
  ? 'coevera.com'
  : 'pipelinersales.com';
